export default __webpack_public_path__ + "static/media/Gulvinder SIngh.972ebd61.jpg";